/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { NameIdType } from "../../../assets/utils/enums/project";
import { ModalWindowType } from "../../../components/ui/modal-window";
import getData, { FetchError } from "../../../api/project-request";
import { API_URL_FINANCE } from "../../../constants";
import { formatDate } from "../../../assets/utils/date-formatter";
import toast from "react-hot-toast";
import CustomToast from "../../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../../assets/utils/enums/toast";
import AppLayout from "../../../components/layout/app/layout";
import Headline from "../../../components/ui/headline";
import { HeadlineTypeEnum } from "../../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../../assets/utils/validation/types";
import { ErrorBlock } from "../../../components/ui/table";
import {
  BoldTextBody,
  LabelText,
  LittleHeadline,
  LittleSubHeadline,
  LittleText,
  NotificationText,
} from "../../../components/typography";
import { Button } from "../../../components/ui/button";
import { COLORS } from "../../../assets/utils/enums/colors";
import { BodyDiv } from "../../../components/components-style";
import financeIcon from "../../../assets/images/icons/line-chart-icon.svg";
import { ItemMainBlock, ButtonSpan } from "../../project/details";
import { LinkText } from "../../../components/ui/error-text";
import { ActionsEnum } from "../../../assets/utils/enums/settings";
import { deleteArrFunc } from "../../../assets/utils/request-function";
import { ErrorVariantEnum } from "../../../assets/utils/enums/error-page";
import ErrorPage from "../../../components/layout/app/error-page";
import handleErrorData from "../../../api/error-handler";
import { findStructureFieldByKey, useStructureStore } from "../../../assets/store/useStructureStore";
import { ObjectsEnum } from "../../../assets/utils/enums/basket";

export default function DetailsExpensePage() {
  const { id } = useParams();
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [amount, setAmount] = useState<string>("");
  const [createdAt, setCreatedAt] = useState<string>("");
  const [type, setType] = useState<string>("");
  const [responsible, setResponsible] = useState<{
    email: string;
    fullName: string;
  }>({ email: "", fullName: "" });
  const [project, setProject] = useState<NameIdType>({ id: "", name: "" });
  const [selling, setSelling] = useState<NameIdType>({ id: "", name: "" });
  const [users, setUsers] = useState<{ email: string; fullName: string }[]>([]);

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const [errorStatus, setErrorStatus] = useState<ErrorVariantEnum | null>(null);

  const fields = useStructureStore(
    (s) => s.structures[ObjectsEnum.EXPENSE].fields
  )

  const [modalWindowSettings, setModalWindowSettings] =
    useState<ModalWindowType>({
      isOpen: false,
      onConfirm: () => { },
      onCancel: () => { },
    });

  const loadData = async () => {
    try {
      const data = await getData(
        `${API_URL_FINANCE}/expense-details?id=${id}`
      );
      if (!data || Object.keys(data).length === 0) {
        setErrorStatus(ErrorVariantEnum.FORBIDDEN);
        return;
      }

      setName(data.name);
      setDescription(data.description || "—");
      setCreatedAt(formatDate(data.createdAt) || "—");
      setResponsible({
        email: data.responsibleEmail,
        fullName: data.responsibleFullName || "",
      });
      setProject({ id: data.projectId, name: data.projectName || "—" });
      setSelling({ id: data.sellingId, name: data.sellingName || "—" });
      setAmount(`${data.amount} ${data.valuta}`);
      setType(data.typeName);

      return true;
    } catch (e) {
      const error = e as FetchError;

      handleErrorData(error, setErrorStatus);
      return false;
    }
  };

  useEffect(() => {
    const init = async () => {
      setIsLoading(true);

      const hasAccess = await loadData();

      if (!hasAccess) {
        setIsLoading(false);
        return;
      }

      setIsLoading(false);
    }

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);


  if (!isLoading && errorStatus) {
    return (
      <ErrorPage
        variant={errorStatus}
        onAction={() => navigate(-1)}
        additionalBtn="Дo Витрат"
        onActionAddBtn={() => navigate("/finance/expense")}
      />
    );
  }

  return (
    <AppLayout
      className="d-flex flex-column align-items-center gap-2"
      blockType="details-project"
      loaderState={isLoading}
      modalWindow={modalWindowSettings}
    >
      <Headline
        headline={HeadlineTypeEnum.FINANCE}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Повернутися до Фінансів"
        btn_link="/finance/expense/main"
      />
      <div className="w-100 d-flex gap-3">
        <BodyDiv
          data-class="detail-main-block"
          className="justify-content-start w-60"
        >
          <div className="d-flex flex-column w-100 gap-3">
            <div className="d-flex align-items-start justify-content-between">
              <span className="d-flex align-items-start gap-3">
                <Button
                  bgcolor={COLORS.warning}
                  txtcolor={COLORS.white}
                  brcolor={"transparent"}
                  width="auto"
                  className="center-btn"
                  brradius="12px"
                  type="large"
                  onClick={() => { }}
                >
                  <img
                    src={financeIcon}
                    className="object-fit-none"
                    alt="task-icon"
                  />
                </Button>
                <span>
                  <LittleHeadline>{name}</LittleHeadline>
                  {findStructureFieldByKey(fields, "date")?.visible && <span className="d-flex align-items-center gap-2">
                    <NotificationText>{findStructureFieldByKey(fields, "date")?.label && "Створено"}:</NotificationText>
                    <BoldTextBody>{createdAt}</BoldTextBody>
                  </span>}
                </span>
              </span>
              <Button
                bgcolor={"transparent"}
                txtcolor={COLORS.warning}
                brcolor={COLORS.warning}
                width="auto"
                className="center-btn"
                brradius="20px"
                type="small"
                onClick={() => { }}
              >
                <LittleText>Витрати</LittleText>
              </Button>
            </div>
          </div>
          <span className="w-100 d-flex gap-5">
            {findStructureFieldByKey(fields, "typeName")?.visible && <ItemMainBlock>
              <NotificationText>{findStructureFieldByKey(fields, "typeName")?.label && "Тип витрат"}</NotificationText>
              <LittleSubHeadline>{type}</LittleSubHeadline>
            </ItemMainBlock>}
            {findStructureFieldByKey(fields, "budget")?.visible && <ItemMainBlock>
              <NotificationText>{findStructureFieldByKey(fields, "budget")?.label ?? "Сума"}</NotificationText>
              <LittleSubHeadline>{amount}</LittleSubHeadline>
            </ItemMainBlock>}
          </span>
          <span className="w-100 d-flex gap-5">
            {findStructureFieldByKey(fields, "project")?.visible && <ItemMainBlock className="">
              <NotificationText>{findStructureFieldByKey(fields, "project")?.label ?? "Проєкт"}</NotificationText>
              {project.name === "—" ? (
                <LittleSubHeadline>{project.name}</LittleSubHeadline>
              ) : (
                <a href={`/projects/details/${project.id}`}>
                  <LittleSubHeadline>{project.name}</LittleSubHeadline>
                </a>
              )}
            </ItemMainBlock>}
            {findStructureFieldByKey(fields, "selling")?.visible && <ItemMainBlock className="max-w-100">
              <NotificationText>{findStructureFieldByKey(fields, "selling")?.label ?? "Продажі"}</NotificationText>
              {selling.name === "—" ? (
                <LittleSubHeadline>{selling.name}</LittleSubHeadline>
              ) : (
                <a href={`/selling/details/${project.id}`}>
                  <LittleSubHeadline>{selling.name}</LittleSubHeadline>
                </a>
              )}
            </ItemMainBlock>}
          </span>
        </BodyDiv>
        <div data-class="detail-add-block" className="w-50 ">
          <BodyDiv className="h-100 gap-4 justify-content-between">
            {findStructureFieldByKey(fields, "responsibleEmail")?.visible && <ItemMainBlock className="w-100 max-w-100">
              <NotificationText className="pb-1">
                {findStructureFieldByKey(fields, "responsibleEmail")?.label ?? "Відповідальний контакт"}
              </NotificationText>
              <LinkText
                mainText={responsible.fullName}
                addText={responsible.email}
                attribute="row"
              />
            </ItemMainBlock>}
            {findStructureFieldByKey(fields, "comment")?.visible && <ItemMainBlock className="max-w-100">
              <NotificationText>{findStructureFieldByKey(fields, "comment")?.label ?? "Опис"}</NotificationText>
              <LittleSubHeadline>{description}</LittleSubHeadline>
            </ItemMainBlock>}
            <ButtonSpan className="">
              <Button
                bgcolor={COLORS.secondary1}
                txtcolor={COLORS["light-gray"]}
                brcolor={"transparent"}
                width="100%"
                className="center-btn"
                brradius="12px"
                type="small"
                onClick={() => {
                  navigate(`/finance/expense/update/${id}`);
                }}
              >
                <LittleText>Редагувати дані</LittleText>
              </Button>
              <Button
                bgcolor={COLORS.warning}
                txtcolor={COLORS["light-gray"]}
                brcolor={"transparent"}
                width="100%"
                className="center-btn"
                brradius="12px"
                type="small"
                onClick={() => {
                  setModalWindowSettings({
                    isOpen: true,
                    onConfirm: () => {
                      if (!id) return;
                      deleteArrFunc(
                        [Number.parseInt(id)],
                        `${API_URL_FINANCE}/expenses`,
                        setIsDeleted
                      );
                      setTimeout(() => {
                        setModalWindowSettings((prev) => ({
                          ...prev,
                          isOpen: false,
                        }));
                        navigate("/finance/expense/main");
                      }, 100);
                    },
                    onCancel: () =>
                      setModalWindowSettings((prev) => ({
                        ...prev,
                        isOpen: false,
                      })),
                    action: ActionsEnum.DELETE,
                  });
                }}
              >
                <LittleText>Видалити елемент</LittleText>
              </Button>
            </ButtonSpan>
          </BodyDiv>
        </div>
      </div>
    </AppLayout>
  );
}
